export const tr = {
    'add-payer': 'ödeyen kişiyi ekleyin',
    'no-payers':
        'Hesabınız için ödeyen kişi belirtilmediği için devre dışı bırakma eşiği ayarlanamaz. Devre dışı bırakma eşiğini ayarlamak için {addPayerLink}.',
    'no-payment-methods':
        'Hesabınızla ilgili ödeyen kişilerden hiçbiri reklam ödemesi yapamaz, bu nedenle devre dışı bırakma eşiği ayarlanamaz. Sorunu çözmek için {writeToUsLink}.',
    'try-later': 'Hata oluştu. Lütfen, tekrar deneyin.',
    'write-to-us': 'bize ulaşın'
};
